const CPF = { mask: '000.000.000-00' }
const CNPJ = { mask: '00.000.000/0000-00' }
const ZIP_CODE = { mask: '00000-000' }

const MONEY = {
  mask: Number,
  thousandsSeparator: '.',
  scale: 0,
}

const NUMBER = {
  mask: Number,
  thousandsSeparator: '',
  scale: 0,
}

const PHONE = {
  mask: [{ mask: '(00) 0000-0000' }, { mask: '(00) 00000-0000' }],
  dispatch (appended, dynamicMasked) {
    const number = (dynamicMasked.value + appended).replace(/\D/g, '')

    return dynamicMasked.compiledMasks.find((m) => {
      if (number.length >= 11) {
        return m.mask.includes('00000-')
      }

      return m.mask.includes('0000-')
    })
  },
}

export default {
  PHONE,
  CPF,
  CNPJ,
  ZIP_CODE,
  MONEY,
  NUMBER,
}
